module.exports = __webpack_public_path__ + "static/media/joanne.bf37d50c.jpg";